import React from "react";
import Sidebar from "../Components/Sidebar";
import "./Mock.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function Mock() {
  const navigate = useNavigate();
  const lang = localStorage.getItem("lang") || "en";
  const isPremium = localStorage.getItem("isPremium") === "true";

  const t = {
    no_access: {
      en: "You need a premium subscription to access the mock test.",
      bn: "মক টেস্ট অ্যাক্সেস করতে আপনাকে প্রিমিয়াম সাবস্ক্রিপশন নিতে হবে।",
    },
    go_to_pricing: {
      en: "Go to Subscription Page",
      bn: "সাবস্ক্রিপশন পেইজে যান",
    },
    mock_title: {
      en: "Mock Test Rules",
      bn: "মক টেস্টের নিয়মাবলী",
    },
    rule_1: {
      en: "This mock test contains 24 questions",
      bn: "এই মক টেস্টে ২৪টি প্রশ্ন রয়েছে",
    },
    rule_2: {
      en: "You must correctly answer 18 questions (75%) to pass",
      bn: "আপনাকে ১৮ টি প্রশ্নের (৭৫%) উত্তর সঠিকভাবে দিতে হবে",
    },
    rule_3: {
      en: "If you exit without completing, remaining unanswered questions will be marked as incorrect",
      bn: "আপনি যদি শেষ না করেই বের হয়ে যান, তবে অবশিষ্ট উত্তর না দেয়া প্রশ্নগুলো ভুল হিসেবে গণ্য হবে",
    },
    start_button: {
      en: "Start Mock Test",
      bn: "মক টেস্ট শুরু করুন",
    },
    alert_fail: {
      en: "Failed to initialize mock exam.",
      bn: "মক পরীক্ষার সূচনা ব্যর্থ হয়েছে।",
    },
    alert_error: {
      en: "Error initializing mock exam.",
      bn: "মক পরীক্ষার সূচনায় ত্রুটি হয়েছে।",
    },
  };

  const handleStartTest = async () => {
    const jwtToken = localStorage.getItem("jwtToken");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/initialize_mock`,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      localStorage.setItem("mockCurrentIndex", 0);

      if (!response.data.error) {
        navigate("/mockquestion", { state: response.data.data });
      } else {
        alert(t.alert_fail[lang]);
      }
    } catch (error) {
      console.error("Error initializing mock:", error);
      alert(t.alert_error[lang]);
    }
  };

  if (!isPremium) {
    return (
      <div className="overview">
        <Sidebar />
        <div className="mock no-access">
          <div className="mock-noaccess-message">{t.no_access[lang]}</div>
          <button className="mock-button" onClick={() => navigate("/pricing")}>
            {t.go_to_pricing[lang]}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="overview">
      <Sidebar />
      <div className="mock">
        <div className="mock-title-container">
          {/* SVG Icon */}
          <div className="mock-title">
            {t.mock_title.en}
            {lang === "bn" && (
              <div style={{ fontFamily: "var(--ff-bangla)" }}>
                {t.mock_title.bn}
              </div>
            )}
          </div>
        </div>

        {[t.rule_1, t.rule_2, t.rule_3].map((rule, i) => (
          <div className="mock-rule-container" key={i}>
            {/* SVG Icon */}
            <div className="mock-rule">
              {rule.en}
              {lang === "bn" && (
                <div style={{ fontFamily: "var(--ff-bangla)" }}>{rule.bn}</div>
              )}
            </div>
          </div>
        ))}

        <button className="mock-button" onClick={handleStartTest}>
          {t.start_button.en}
          {lang === "bn" && (
            <div style={{ fontFamily: "var(--ff-bangla)" }}>
              {t.start_button.bn}
            </div>
          )}
        </button>
      </div>
    </div>
  );
}

export default Mock;
